import { CampaignSectionType, CampaignTabSection } from 'modules/iterableGoals/types';
import { CampaignContribution } from '../sections';
import { CampaignContributionWrapper, CampaignTabWrapper } from './Styled';
import { TabSections } from './TabSections';

const campaignSections: CampaignSectionType[] = [
  {
    SectionWrapper: CampaignContributionWrapper,
    SectionComponent: CampaignContribution,
    section: CampaignTabSection.CAMPAIGN_CONTRIBUTION,
  },
];

export const CampaignsTab = () => (
  <CampaignTabWrapper data-test="goal-analytics-campaign-tab-content">
    <TabSections tabSectionList={campaignSections} />
  </CampaignTabWrapper>
);
